import { SelectItemVm } from '@treasury/presentation/components/forms';

export enum PaymentOption {
    RegularPayment = 1,
    PrincipalOnly = 2,
}

export function getPaymentOptions() {
    return Object.values(PaymentOption).filter(value => typeof value === 'number');
}

const PaymentLabelMap: Record<PaymentOption, string> = {
    [PaymentOption.RegularPayment]: 'Regular Payment',
    [PaymentOption.PrincipalOnly]: 'Principal Only',
};

export function mapPaymentOptionToVm(option: PaymentOption): SelectItemVm<PaymentOption> {
    if (!(option in PaymentLabelMap)) {
        throw new Error(`Unsupported payment option: ${option}`);
    }

    return {
        label: PaymentLabelMap[option],
        value: option,
    };
}
